import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { updateTaxRate } from "../../../stores/services/tax-rates.service";
import { useSelector } from "react-redux";
import Select from "react-select";

const EditTaxRate = () => {
  const renderCategoryDropdown = [
    { label: "Stock Funds", value: "Stock Funds" },
    { label: "Other Funds", value: "Other Funds" },
  ];
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const history = useHistory();
  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";

  const [individual_filer, setIndividualFiler] = useState("0");
  const [individual_non_filer, setIndividualNonFiler] = useState("0");
  const [individual_exempted, setIndividualExempted] = useState("0");
  const [corporate_filer, setCorporateFiler] = useState("0");
  const [corporate_non_filer, setCorporateNonFiler] = useState("0");
  const [corporate_exempted, setCorporateExempted] = useState("0");

  const [individual_filerError, setIndividualFilerError] = useState("");
  const [individual_non_filerError, setIndividualNonFilerError] = useState("");
  const [individual_exemptedError, setIndividualExemptedError] = useState("");
  const [corporate_filerError, setCorporateFilerError] = useState("");
  const [corporate_non_filerError, setCorporateNonFilerError] = useState("");
  const [corporate_exemptedError, setCorporateExemptedError] = useState("");

  const [category, setCategory] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [period, setPeriod] = useState("");
  const [cgtExempAfterYears, setCgtExempAfterYears] = useState("0");

  const [div_individual_filer, setDivIndividualFiler] = useState("0");
  const [div_individual_non_filer, setDivIndividualNonFiler] = useState("0");
  const [div_individual_exempted, setDivIndividualExempted] = useState("0");
  const [div_corporate_filer, setDivCorporateFiler] = useState("0");
  const [div_corporate_non_filer, setDivCorporateNonFiler] = useState("0");
  const [div_corporate_exempted, setDivCorporateExempted] = useState("0");

  const [div_individual_filerError, setDivIndividualFilerError] = useState("0");
  const [div_individual_non_filerError, setDivIndividualNonFilerError] =
    useState("0");
  const [div_individual_exemptedError, setDivIndividualExemptedError] =
    useState("0");
  const [div_corporate_filerError, setDivCorporateFilerError] = useState("0");
  const [div_corporate_non_filerError, setDivCorporateNonFilerError] =
    useState("0");
  const [div_corporate_exemptedError, setDivCorporateExemptedError] =
    useState("0");

  useEffect(() => {
    const obj = JSON.parse(sessionStorage.getItem("selected_tax_rate") || "");
    setIndividualFiler(obj.individual_filer);
    setIndividualNonFiler(obj.individual_non_filer);
    setIndividualExempted(obj.individual_exempted);
    setCorporateFiler(obj.corporate_filer);
    setCorporateNonFiler(obj.corporate_non_filer);
    setCorporateExempted(obj.corporate_exempted);
    setPeriod(obj.period);
    setStartDate(
      obj.start_date ? moment(obj.start_date).format("YYYY-MM-DD") : ""
    );
    setEndDate(obj.end_date ? moment(obj.end_date).format("YYYY-MM-DD") : "");
    setCategory(obj.category);
    setCgtExempAfterYears(obj.cgt_exempt_after || "0");

    setDivIndividualFiler(obj?.div_individual_filer || "0");
    setDivIndividualNonFiler(obj?.div_individual_non_filer || "0");
    setDivIndividualExempted(obj?.div_individual_exempted || "0");
    setDivCorporateFiler(obj?.div_corporate_filer || "0");
    setDivCorporateNonFiler(obj?.div_corporate_non_filer || "0");
    setDivCorporateExempted(obj?.div_corporate_exempted || "0");
  }, []);

  const [loading, setLoading] = useState(false);

  const updateTaxRates = async () => {
    if (validate()) {
      try {
        setLoading(true);
        const response = await updateTaxRate(
          amc_code,
          email,
          individual_filer,
          individual_non_filer,
          individual_exempted,
          corporate_filer,
          corporate_non_filer,
          corporate_exempted,
          period,
          startDate,
          endDate,
          category,
          +cgtExempAfterYears || 0,
          div_individual_filer,
          div_individual_non_filer,
          div_individual_exempted,
          div_corporate_filer,
          div_corporate_non_filer,
          div_corporate_exempted
        );
        if (response.data.status == 200) {
          toast.success(response.data.message);
          sessionStorage.removeItem("selected_tax_rate");
          setTimeout(() => {
            history.replace("/admin/tax-rates");
          }, 3000);
        } else {
          setLoading(false);
          toast.error(response.data.message);
        }
      } catch (error: any) {
        setLoading(false);
        if (error.response !== undefined) {
          toast.error(error.response.data.message?.toString());
        } else {
          toast.error("Something went wrong!");
        }
      }
    }
  };

  const validate = () => {
    let individualFilerErr = "";
    let individualNonFilerErr = "";
    let individualExemptedErr = "";
    let corporateFilerErr = "";
    let corporateNonFilerErr = "";
    let corporateExemptedErr = "";

    let divIndividualFilerErr = "";
    let divIndividualNonFilerErr = "";
    let divIndividualExemptedErr = "";
    let divCorporateFilerErr = "";
    let divCorporateNonFilerErr = "";
    let divCorporateExemptedErr = "";

    individual_filer.trim() === ""
      ? (individualFilerErr = "required-border")
      : (individualFilerErr = "");
    individual_non_filer.trim() === ""
      ? (individualNonFilerErr = "required-border")
      : (individualNonFilerErr = "");
    individual_exempted.trim() === ""
      ? (individualExemptedErr = "required-border")
      : (individualExemptedErr = "");
    corporate_filer.trim() === ""
      ? (corporateFilerErr = "required-border")
      : (corporateFilerErr = "");
    corporate_non_filer.trim() === ""
      ? (corporateNonFilerErr = "required-border")
      : (corporateNonFilerErr = "");
    corporate_exempted.trim() === ""
      ? (corporateExemptedErr = "required-border")
      : (corporateExemptedErr = "");

    div_individual_filer.trim() === ""
      ? (divIndividualFilerErr = "required-border")
      : (divIndividualFilerErr = "");

    div_individual_non_filer.trim() === ""
      ? (divIndividualNonFilerErr = "required-border")
      : (divIndividualNonFilerErr = "");

    div_individual_exempted.trim() === ""
      ? (divIndividualExemptedErr = "required-border")
      : (divIndividualExemptedErr = "");

    div_corporate_filer.trim() === ""
      ? (divCorporateFilerErr = "required-border")
      : (divCorporateFilerErr = "");

    div_corporate_non_filer.trim() === ""
      ? (divCorporateNonFilerErr = "required-border")
      : (divCorporateNonFilerErr = "");

    div_corporate_exempted.trim() === ""
      ? (divCorporateExemptedErr = "required-border")
      : (divCorporateExemptedErr = "");

    if (
      individualFilerErr ||
      individualNonFilerErr ||
      individualExemptedErr ||
      corporateFilerErr ||
      corporateNonFilerErr ||
      corporateExemptedErr ||
      divIndividualFilerErr ||
      divIndividualNonFilerErr ||
      divIndividualExemptedErr ||
      divCorporateFilerErr ||
      divCorporateNonFilerErr ||
      divCorporateExemptedErr
    ) {
      setIndividualFilerError(individualFilerErr);
      setIndividualNonFilerError(individualNonFilerErr);
      setIndividualExemptedError(individualExemptedErr);
      setCorporateFilerError(corporateFilerErr);
      setCorporateNonFilerError(corporateNonFilerErr);
      setCorporateExemptedError(corporateExemptedErr);

      setDivIndividualFilerError(divIndividualFilerErr);
      setDivIndividualNonFilerError(divIndividualNonFilerErr);
      setDivIndividualExemptedError(divIndividualExemptedErr);
      setDivCorporateFilerError(divCorporateFilerErr);
      setDivCorporateNonFilerError(divCorporateNonFilerErr);
      setDivCorporateExemptedError(divCorporateExemptedErr);

      return false;
    } else {
      return true;
    }
  };

  const selectedCategory = React.useMemo(() => {
    return category
      ? {
          value: category,
          label: category,
        }
      : null;
  }, [category]);

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
        ? "hsla(291, 64%, 42%, 1)"
        : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
        ? "#2b3553"
        : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
      '& .react-select__input input[type="color"]': {
        color: theme === "dark" ? "red" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />

              <div className="d-flex mt-2">
                <h4 className="card-title text-primary">
                  {" "}
                  <i
                    className="fa fa-angle-left mr-1 pointer"
                    onClick={() => {
                      sessionStorage.removeItem("selected_tax_rate");
                      history.replace("/admin/tax-rates");
                    }}
                  ></i>
                  Edit - Tax Rates
                </h4>

                <Link
                  to="/admin/tax-rates"
                  className="btn btn-primary btn-sm ml-auto"
                  replace
                >
                  <i className="fa fa-eye mr-2"></i>View All
                </Link>
              </div>
              <div className="card">
                <div className="card-header title-row">
                  <h2 className="cart-title">Details</h2>
                </div>

                <div className="card-body">
                  <Row>
                    <Col md="6">
                      <div className="form-group">
                        <label>Category</label>
                        <div>
                          <div className="">
                            <Select
                              value={selectedCategory}
                              label={"Select Category"}
                              onChange={(e) => {
                                setCategory(e?.value);
                              }}
                              menuPortalTarget={document.body}
                              menuShouldBlockScroll={true}
                              isClearable={true}
                              isSearchable={true}
                              name="color"
                              options={renderCategoryDropdown}
                              styles={customStyles}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="form-group">
                        <label>Financial Year Start Date </label>
                        <input
                          style={{
                            colorScheme: theme == "light" ? "light" : "dark",
                          }}
                          type="date"
                          className={`form-control  w-100 `}
                          value={startDate}
                          readOnly
                        />
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="form-group">
                        <label>Financial Year End Date</label>
                        <input
                          style={{
                            colorScheme: theme == "light" ? "light" : "dark",
                          }}
                          type="date"
                          className={`form-control  w-100 `}
                          value={endDate}
                          readOnly
                        />
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="form-group">
                        {/* <label>Financial Year Period</label>	 */}
                        <label>Financial Period</label>
                        <input
                          type="text"
                          placeholder="Period"
                          readOnly
                          className={`form-control  w-100 `}
                          value={period}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="card">
                <div className="card-header title-row">
                  <h2 className="cart-title">CGT</h2>
                </div>
                <div className="card-body">
                  <Row>
                    <Col md="3">
                      <div className="form-group">
                        <label>
                          Individual Filer{" "}
                          <span className="color-amber">*</span>
                        </label>
                        <input
                          type="number"
                          className={`form-control  w-100 text-right ${individual_filerError}`}
                          value={individual_filer}
                          onChange={(e) => {
                            setIndividualFiler(e.target.value);
                            setIndividualFilerError("");
                          }}
                        />
                      </div>
                    </Col>
                    <Col md="3">
                      <div className="form-group">
                        <label>
                          Individual Non-Filer{" "}
                          <span className="color-amber">*</span>
                        </label>
                        <input
                          type="number"
                          className={`form-control  w-100 text-right ${individual_non_filerError}`}
                          value={individual_non_filer}
                          onChange={(e) => {
                            setIndividualNonFiler(e.target.value);
                            setIndividualNonFilerError("");
                          }}
                        />
                      </div>
                    </Col>
                    <Col md="3">
                      <div className="form-group">
                        <label>
                          Individual Exempted{" "}
                          <span className="color-amber">*</span>
                        </label>
                        <input
                          type="number"
                          className={`form-control  w-100 text-right ${individual_exemptedError}`}
                          value={individual_exempted}
                          onChange={(e) => {
                            setIndividualExempted(e.target.value);
                            setIndividualExemptedError("");
                          }}
                        />
                      </div>
                    </Col>
                    <Col md="3">
                      <div className="form-group">
                        <label>
                          Corporate Filer <span className="color-amber">*</span>
                        </label>
                        <input
                          type="number"
                          className={`form-control w-100 text-right ${corporate_filerError}`}
                          value={corporate_filer}
                          onChange={(e) => {
                            setCorporateFiler(e.target.value);
                            setCorporateFilerError("");
                          }}
                        />
                      </div>
                    </Col>

                    <Col md="3">
                      <div className="form-group">
                        <label>
                          Corporate Non-Filer{" "}
                          <span className="color-amber">*</span>
                        </label>
                        <input
                          type="number"
                          className={`form-control w-100 text-right ${corporate_non_filerError}`}
                          value={corporate_non_filer}
                          onChange={(e) => {
                            setCorporateNonFiler(e.target.value);
                            setCorporateNonFilerError("");
                          }}
                        />
                      </div>
                    </Col>
                    <Col md="3">
                      <div className="form-group">
                        <label>
                          Corporate Exempted{" "}
                          <span className="color-amber">*</span>
                        </label>
                        <input
                          type="number"
                          className={`form-control w-100 text-right ${corporate_exemptedError}`}
                          value={corporate_exempted}
                          onChange={(e) => {
                            setCorporateExempted(e.target.value);
                            setCorporateExemptedError("");
                          }}
                        />
                      </div>
                    </Col>
                    <Col md="3">
                      <div className="form-group">
                        <label>CGT Exempt After Years </label>
                        <input
                          type="number"
                          className={`form-control w-100 text-right `}
                          value={cgtExempAfterYears}
                          onChange={(e) => {
                            if (
                              e.target.value &&
                              +e.target.value > 0 &&
                              +e.target.value < 11
                            ) {
                              setCgtExempAfterYears(e.target.value);
                            } else if (!e.target.value) {
                              setCgtExempAfterYears("0");
                            }
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="card">
                <div className="card-header title-row">
                  <h2 className="cart-title">Dividend</h2>
                </div>
                <div className="card-body">
                  <Row>
                    <Col md="3">
                      <div className="form-group">
                        <label>
                          Individual Filer{" "}
                          <span className="color-amber">*</span>
                        </label>
                        <input
                          type="number"
                          className={`form-control  w-100 text-right ${div_individual_filerError}`}
                          value={div_individual_filer}
                          onChange={(e) => {
                            setDivIndividualFiler(e.target.value);
                            setDivIndividualFilerError("");
                          }}
                        />
                      </div>
                    </Col>
                    <Col md="3">
                      <div className="form-group">
                        <label>
                          Individual Non-Filer{" "}
                          <span className="color-amber">*</span>
                        </label>
                        <input
                          type="number"
                          className={`form-control  w-100 text-right ${div_individual_non_filerError}`}
                          value={div_individual_non_filer}
                          onChange={(e) => {
                            setDivIndividualNonFiler(e.target.value);
                            setDivIndividualNonFilerError("");
                          }}
                        />
                      </div>
                    </Col>
                    <Col md="3">
                      <div className="form-group">
                        <label>
                          Individual Exempted{" "}
                          <span className="color-amber">*</span>
                        </label>
                        <input
                          type="number"
                          className={`form-control  w-100 text-right ${div_individual_exemptedError}`}
                          value={div_individual_exempted}
                          onChange={(e) => {
                            setDivIndividualExempted(e.target.value);
                            setDivIndividualExemptedError("");
                          }}
                        />
                      </div>
                    </Col>
                    <Col md="3">
                      <div className="form-group">
                        <label>
                          Corporate Filer <span className="color-amber">*</span>
                        </label>
                        <input
                          type="number"
                          className={`form-control w-100 text-right ${div_corporate_filerError}`}
                          value={div_corporate_filer}
                          onChange={(e) => {
                            setDivCorporateFiler(e.target.value);
                            setDivCorporateFilerError("");
                          }}
                        />
                      </div>
                    </Col>

                    <Col md="3">
                      <div className="form-group">
                        <label>
                          Corporate Non-Filer{" "}
                          <span className="color-amber">*</span>
                        </label>
                        <input
                          type="number"
                          className={`form-control w-100 text-right ${div_corporate_non_filerError}`}
                          value={div_corporate_non_filer}
                          onChange={(e) => {
                            setDivCorporateNonFiler(e.target.value);
                            setDivCorporateNonFilerError("");
                          }}
                        />
                      </div>
                    </Col>
                    <Col md="3">
                      <div className="form-group">
                        <label>
                          Corporate Exempted{" "}
                          <span className="color-amber">*</span>
                        </label>
                        <input
                          type="number"
                          className={`form-control w-100 text-right ${div_corporate_exemptedError}`}
                          value={div_corporate_exempted}
                          onChange={(e) => {
                            setDivCorporateExempted(e.target.value);
                            setDivCorporateExemptedError("");
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="form-group">
                <button
                  className="btn btn-primary ml-3"
                  onClick={updateTaxRates}
                  disabled={Boolean(loading)}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border login-txt spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span className="login-txt"> Updating...</span>
                    </>
                  ) : (
                    <span>Update</span>
                  )}
                </button>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default EditTaxRate;
